var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInsertPhoto(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 11.1667V1.83333C12 1.1 11.4 0.5 10.6667 0.5H1.33333C0.6 0.5 0 1.1 0 1.83333V11.1667C0 11.9 0.6 12.5 1.33333 12.5H10.6667C11.4 12.5 12 11.9 12 11.1667ZM3.93333 7.82L5.33333 9.50667L7.4 6.84667C7.53333 6.67333 7.8 6.67333 7.93333 6.85333L10.2733 9.97333C10.44 10.1933 10.28 10.5067 10.0067 10.5067H2.01333C1.73333 10.5067 1.58 10.1867 1.75333 9.96667L3.41333 7.83333C3.54 7.66 3.79333 7.65333 3.93333 7.82Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertPhoto);
export default __webpack_public_path__ + "static/media/insertPhoto.4396702489ae8813919e682783c4ba8b.svg";
export { ForwardRef as ReactComponent };